module.exports = __webpack_public_path__ + "static/img/bg-17.88c0253.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/history-bg/bg-17.png
// module id = q37x
// module chunks = 0